// 用户输入在表格软件中始终作为文本，双引号仅处理CSV结构，不能防止公式执行。
export function csvCell (value) {
  let text = value == null ? '' : String(value)
  if (typeof value !== 'number' && /^[\s\u0000-\u001f]*[=+\-@]/.test(text)) text = "'" + text
  return '"' + text.replace(/"/g, '""') + '"'
}
